import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const SchemeBankModal = ({open, handleClose, bankDetails}) => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      boxShadow: 24,
      width: "50%",
    };
    return (
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            className="bg-prime-20 px-2"
          >
            <div className="d-flex justify-content-between align-items-center py-2">
              <span className="fw-600 fs-16px ff-poppins">
                Bank Account Details
              </span>
              <i
                className="icon-close_circle_fill cursor-pointer"
                onClick={handleClose}
              ></i>
            </div>
          </Typography>
          <Typography>
            <div className="ff-poppins px-1 pb-4 m-0">
              <div className="row m-0">
                <div className="px-1 col-4">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Bank
                    </label>
                    <p className="fs-14px border-bottom-only">{bankDetails.bank_name}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Branch
                    </label>
                    <p className="fs-14px border-bottom-only">{bankDetails.branch_name}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Account Type
                    </label>
                    <p className="fs-14px border-bottom-only">{bankDetails?.account_type?.toUpperCase()}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Account No.
                    </label>
                    <p className="fs-14px border-bottom-only">{bankDetails.account_no}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Account Name
                    </label>
                    <p className="fs-14px border-bottom-only">{bankDetails.account_name}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Bank email
                    </label>
                    <p className="fs-14px border-bottom-only">&nbsp;{bankDetails.email}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      IFSC Code (IFMS)
                    </label>
                    <p className="fs-14px border-bottom-only">&nbsp;{bankDetails?.ifsc_code?.toUpperCase()}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      IFSC Code (Bank)
                    </label>
                    <p className="fs-14px border-bottom-only">&nbsp;{bankDetails?.ifsc_code_bank?.toUpperCase()}</p>
                  </span>
                </div>

                <div className="col-4 px-1">
                  <span className="d-flex flex-column p-0 mt-3">
                    <label htmlFor="text" className="fs-12px text-prime-100">
                      Bank Contact
                    </label>
                    <p className="fs-14px border-bottom-only">&nbsp;{bankDetails.mobile}</p>
                  </span>
                </div>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    )
}

export default SchemeBankModal;